<script lang="ts" setup>
import { useDsFocusTrap } from '~/composables/ds/useDsFocusTrap';
import { dsRefocus } from '~/composables/ds/dsFocus';

withDefaults(defineProps<{
  title?: string;
  count?: number;
  height?: string;
}>(), {});

const emit = defineEmits<{ close: [] }>();

const sheetRef = ref<HTMLElement | null>(null);
const titleId = `gm-sheet-title-${useId()}`;
// The parent mounts the sheet to open it and unmounts it to close it: the trap never sees it close.
const opener = import.meta.client ? document.activeElement as HTMLElement | null : null;
useDsFocusTrap(sheetRef, computed(() => true), { onEscape: () => emit('close'), restoreFocus: false });
onBeforeUnmount(() => dsRefocus(opener));
</script>

<template>
  <div
    class="gm-sheet-scrim"
    @click="emit('close')"
  >
    <div
      ref="sheetRef"
      class="gm-sheet"
      role="dialog"
      aria-modal="true"
      :aria-labelledby="titleId"
      :style="height ? { height, maxHeight: height } : undefined"
      @click.stop
    >
      <div class="gm-sheet-grab" />
      <div class="gm-sheet-hd">
        <span
          :id="titleId"
          class="gm-sheet-title"
        >
          {{ title }}
          <span
            v-if="count != null"
            class="gm-sl-count"
          >{{ count }}</span>
        </span>
        <button
          class="gm-sheet-x"
          aria-label="Fermer"
          @click="emit('close')"
        >
          <DsIcon
            name="times"
            :size="14"
          />
        </button>
      </div>
      <div class="gm-sheet-body">
        <slot />
      </div>
      <div
        v-if="$slots.footer"
        class="gm-sheet-ft"
      >
        <slot name="footer" />
      </div>
    </div>
  </div>
</template>
